import React, { useEffect, useState } from 'react';
import './styles';
import * as strings from './strings';
import * as S from './styles';
import { useSelector } from 'react-redux';
import UIIconButton from '../../../../../components/UI/UIIconButton';
import { BellIcon, CopyIcon, MusicNoteIcon, MutedIcon } from '../../../../../assets/icons';
import UIListInputRow from '../../../../../components/UI/UIListInputRow';
import { Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component';
import { getExternalBaseUrl } from '../../../../../utils/Helpers/AppHelper';
import UIAudioFile from '../../../../../components/UI/UIAudioFile/UIAudioFile';
import UIModal from '../../../../../components/UI/UIModal';
import { virtualTourMusicOptions } from '../../../../../utils/Helpers/VirtualTourHelper';
import Queries from '../../../../../utils/API/Queries';
import { FILE_TYPE_AUDIO } from '../../../../../utils/Config/Constants';
import { getApiUrl } from '../../../../../utils/API/APIConfig';
import UIOverlayCard from '../../../../../components/UI/UIOverlayCard';
import { getScreenTypeSelector } from '../../../../../redux/selectors/ControlSelectors';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { toast } from 'react-toastify';
import { useApolloClient } from '@apollo/react-hooks';
import { GET_LISTING_PROPERTY_WEBSITE } from './queries';
import { CHILD_TYPE, HEADER_TYPE } from '../../../../../components/UI/UIListInputRow/config';
import { UI_ICON_BUTTON_FILL_TYPE, UI_ICON_BUTTON_OUTLINE_TYPE } from '../../../../../components/UI/UIIconButton/config';
import ListingInfo from '../ListingInfo/ListingInfo';
import { div_ListingVTInfo } from './styles';

export default function ListingPropertyWebsite({ listingId }: ListingPropertyWebsite) {
	const screenType = useSelector(getScreenTypeSelector);
	const client = useApolloClient();

	const [listing, setListing] = useState<ListingType>();
	const [analytics, setAnalytics] = useState<object>({});
	const [MUSIC, setMUSIC] = useState(virtualTourMusicOptions);
	const [audioRefs, setAudioRefs] = useState<any[]>([]);
	const [showSelectMusicModal, setShowSelectMusicModal] = useState(false);
	const [songPlaying, setSongPlaying] = useState<FileType>();
	const [updateListingPropertyWebsite] = useMutation(Queries.UPDATE_LISTING);

	const [getListing, { data: listingData }] = useLazyQuery(GET_LISTING_PROPERTY_WEBSITE, {
		variables: { id: listingId }
	});

	useEffect(() => {
		(async () => {
			fetch(`${getApiUrl().replace('/api', '')}/analytics/visits?pathContains=/virtualtour/${listingId}`, {
				method: 'GET',
				headers: {
					Accept: 'application/json'
				}
			})
				.then((response) => {
					response
						.json()
						.then((analytics) => {
							setAnalytics(analytics);
						})
						.catch((error) => {
							setAnalytics({});
							toast.error(error.message);
						});
				})
				.catch((error) => {
					setAnalytics({});
					toast.error(error.message);
				});
			await getListing();
		})();
	}, []);

	useEffect(() => {
		if (listingData) {
			setListing(listingData['listing']);
		}
	}, [listingData]);

	if (!listing) return null;

	const updateListingApi = async (key, value, message) => {
		let variables = {
			id: listingId,
			[key]: value
		};
		const response = await updateListingPropertyWebsite({ variables });
		const { updateListing } = response['data'];
		if (updateListing) {
			if (message) {
				toast.success(message);
			} else {
				toast.success(strings.listingUpdateSuccess + key + '!');
			}
		}
		await getListing();
	};

	//Mark: Component functions
	const autoplayOn = async () => {
		if (listing) {
			let flags = { AUTOPLAY: true };
			if (listing) {
				flags = {
					...listing.flags,
					AUTOPLAY: true
				};
			}
			let variables = {
				id: listing.id,
				flags
			};
			const response = await updateListingPropertyWebsite({ variables });

			if (response['data']) {
				await getListing();
				toast.success(strings.autoplayOn);
			}
		}
	};

	const autoplayOff = async () => {
		if (listing) {
			let flags = { AUTOPLAY: false };
			if (listing) {
				flags = {
					...listing.flags,
					AUTOPLAY: false
				};
			}
			const response = await client.mutate({
				mutation: Queries.UPDATE_LISTING,
				variables: {
					id: listingId,
					flags
				}
			});
			if (response['data']) {
				await getListing();
				toast.success(strings.autoplayOff);
			}
		}
	};

	const selectFile = async (audioFile) => {
		if (!audioFile) {
			await updateListingApi('audioFile', null, strings.successUpdateSong);
		} else if (listing.audioFile) {
			const response = await client.mutate({
				mutation: Queries.UPDATE_FILE,
				variables: {
					listing: listingId,
					fileId: listing.audioFile.id,
					filename: audioFile.filename,
					originalUrl: audioFile.originalUrl,
					watermarkUrl: audioFile.originalUrl
				}
			});
			if (response['data']) {
				toast.success(strings.updateSongChoice + audioFile.filename);
			}
		} else {
			const response = await client.mutate({
				mutation: Queries.CREATE_FILE,
				variables: {
					type: FILE_TYPE_AUDIO,
					index: 0,
					status: 'live',
					listing: listingId,
					filename: audioFile.filename,
					originalUrl: audioFile.originalUrl,
					watermarkUrl: audioFile.originalUrl
				}
			});
			const { createFile } = response['data'];
			if (createFile) {
				await updateListingApi('audioFile', createFile.id, strings.addedSongSuccess);
			}
		}
	};

	const toggleAutoplay = async () => {
		let { flags } = listing;

		if (!flags) {
			flags = { AUTOPLAY: false };
		}

		const { AUTOPLAY } = flags;

		if (!AUTOPLAY) {
			await autoplayOn();
		} else {
			await autoplayOff();
		}
	};

	const handlePlay = async (musicFile) => {
		const isFilePlaying = songPlaying && songPlaying.filename === musicFile.filename;
		//Go through all elements that aren't paused and pause them and seek to 0.
		for (let i = 0; i < MUSIC.length; i++) {
			if (songPlaying && songPlaying.filename === MUSIC[i].filename) {
				//Seek to 0
				MUSIC[i].ref.audioEl.current.currentTime = 0;
				MUSIC[i].ref.audioEl.current.pause();
			}
		}
		if (!isFilePlaying) {
			await musicFile.ref.audioEl.current.play();
			setSongPlaying(musicFile);
		} else {
			musicFile.ref.audioEl.current.pause();
			setSongPlaying(undefined);
		}

		MUSIC[MUSIC.indexOf(musicFile)] = musicFile;
		setMUSIC(MUSIC);
	};

	const renderAnalytics = () => {
		if (!analytics) {
			return;
		}
		const renderItem = (key, title) => {
			if (!analytics || !analytics[key]) return;
			return (
				<div key={key} className='listingAnalytics__item'>
					<p className='listingAnalytics__item--title'>{title}</p>
					<p className='listingAnalytics__item--views'>{analytics[key]['pageviews']} views</p>
					<p className='listingAnalytics__item--users'>{analytics[key]['users']} users</p>
				</div>
			);
		};

		return (
			<>
				<UIListInputRow type={HEADER_TYPE} label={'Virtual tour analytics'} style={{ marginTop: 24 }} />
				<UIListInputRow type={CHILD_TYPE}>
					<div className='listingAnalytics'>
						{renderItem('today', 'Day')}
						{renderItem('week', 'Week')}
						{renderItem('month', 'Month')}
						{renderItem('year', 'Year')}
					</div>
				</UIListInputRow>
				<p className='general-overlay-sub-text'>{strings.analyticsWarning}</p>
			</>
		);
	};

	const renderVirtualTourCard = () => {
		let AUTOPLAY;
		if (listing.flags) {
			AUTOPLAY = listing.flags.AUTOPLAY;
		}

		let selectedSong;

		if (listing.audioFile) {
			selectedSong = listing.audioFile;
		}

		const virtualTourPath = `/virtualtour/${listingId}`;

		return (
			<>
				<UIListInputRow type={CHILD_TYPE} className='listing__no-margin'>
					<div className='listingInfoCard__links'>
						<Link to={{ pathname: getExternalBaseUrl() + virtualTourPath }} target='_blank'>
							<UIIconButton dark type={UI_ICON_BUTTON_FILL_TYPE} text={strings.vtButton} />
						</Link>
						<CopyToClipboard onCopy={() => toast.success(strings.copyLink)} text={getExternalBaseUrl() + virtualTourPath}>
							<UIIconButton type={UI_ICON_BUTTON_OUTLINE_TYPE} icon={CopyIcon} text={'copy link'} onClick={(e) => e.stopPropagation()} />
						</CopyToClipboard>
					</div>
				</UIListInputRow>
				<UIListInputRow type={CHILD_TYPE} label={strings.musicLabel}>
					<div className='listing__music'>
						{selectedSong && (
							<UIAudioFile
								noCheckmark
								audioFile={selectedSong}
								isSelected={true}
								selectFile={selectFile}
								refPool={audioRefs}
								addRefToPool={(ref) => setAudioRefs([...audioRefs, ref])}
							/>
						)}
						{!selectedSong && (
							<UIIconButton
								dark
								type={UI_ICON_BUTTON_FILL_TYPE}
								icon={MusicNoteIcon.grey}
								iconPadding={2}
								className='listing__music--button'
								text={strings.addMusicButton}
								onClick={() => setShowSelectMusicModal(true)}
							/>
						)}
					</div>
				</UIListInputRow>
				{/*{selectedSong && (*/}
				{/*	<UIListInputRow className='listing__no-margin' label={'Mute Audio by default?'} type={CHILD_TYPE}>*/}
				{/*		<div className='listingInfoCard__autoplay'>*/}
				{/*			<UIIconButton*/}
				{/*				key={AUTOPLAY}*/}
				{/*				type={UI_ICON_BUTTON_OUTLINE_TYPE}*/}
				{/*				style={{ margin: '8px 0 0 0' }}*/}
				{/*				className='listingInfoCard__autoplay--btn'*/}
				{/*				onClick={toggleAutoplay}*/}
				{/*				icon={!AUTOPLAY ? MutedIcon.white : BellIcon.white}*/}
				{/*				text={AUTOPLAY ? strings.unMute : strings.mute}*/}
				{/*			/>*/}
				{/*		</div>*/}
				{/*	</UIListInputRow>*/}
				{/*)}*/}
			</>
		);
	};

	const renderMusicSelectModal = () => {
		let selectedSong;

		if (listing.audioFile) {
			selectedSong = listing.audioFile;
		}

		const hideModal = async () => {
			if (songPlaying) {
				await handlePlay(songPlaying);
			}
			setShowSelectMusicModal(false);
		};
		return (
			<UIModal condition={showSelectMusicModal}>
				<UIOverlayCard hideModal={hideModal} title={strings.selectSongTitle}>
					{MUSIC.map((audioFile) => (
						<UIAudioFile
							key={audioFile.filename}
							audioFile={audioFile}
							selectFile={selectFile}
							isSelected={selectedSong && audioFile.filename === selectedSong.filename}
							refPool={audioRefs}
							addRefToPool={(ref) => setAudioRefs([...audioRefs, ref])}
						/>
					))}
					{screenType === 'mobile' && (
						<UIIconButton type={UI_ICON_BUTTON_FILL_TYPE} text={strings.selectSongButton} onClick={hideModal} style={{ margin: '16px 0 0 0' }} />
					)}
				</UIOverlayCard>
			</UIModal>
		);
	};

	return (
		<div className='listingMarketingCenter'>
			<S.div_ListingVT>
				<div className='listingMarketingCenter__content'>
					{renderVirtualTourCard()}
					{/*{renderAnalytics()}*/}
				</div>
			</S.div_ListingVT>
			<S.div_ListingVTInfo>
				<ListingInfo listingId={listingId} />
			</S.div_ListingVTInfo>
			{renderMusicSelectModal()}
		</div>
	);
}
